<div class="flex flex-col flex-1 min-h-0 overflow-hidden rounded-2xl bg-white shadow-module mt-2">
  @if (!addendumView()) {
    <div class="flex flex-wrap items-center gap-2 pt-4 px-4 shrink-0">
      <h2 class="text-title-1 font-medium text-primary-500 m-0 font-title">
        Deposits History <span class="text-emerald-700">({{ sortedDeposits().length }})</span>
      </h2>

      <div class="flex flex-1 flex-wrap items-center justify-end gap-2">
        <!-- @if (canBulkDelete()) {
        <p-button
          label="Bulk Delete"
          icon="pi pi-trash"
          severity="danger"
          [outlined]="true"
          size="small"
          [disabled]="selectedDeposits.length === 0"
          styleClass="max-sm:[&>.p-button-label]:!hidden"
          (onClick)="confirmBulkDelete()"
        />
      } -->
        <!-- <p-button
        label="Import From"
        icon="pi pi-file-import"
        severity="primary"
        [outlined]="true"
        size="small"
        styleClass="max-sm:[&>.p-button-label]:!hidden"
        (onClick)="importFrom.emit()"
      /> -->
        <p-button
          label="New Deposit"
          icon="pi pi-plus"
          size="small"
          styleClass="max-md:!w-8 max-md:!h-8 max-md:!p-0 max-md:!rounded-full max-md:[&>.p-button-label]:!hidden"
          (onClick)="onAddNewDeposits()"
        />
      </div>
    </div>
  }

  <p-dialog
    [header]="depositService.depositId ? 'Edit Deposit' : 'New Deposit'"
    [visible]="depositService.addNewDeposits"
    (onHide)="resetForm()"
    [modal]="true"
    [closable]="true"
    [style]="{ width: '36rem' }"
    [appendTo]="'body'"
  >
    <form [formGroup]="form" class="flex flex-col gap-5 pt-1">
      <div class="grid grid-cols-2 gap-5">
        <div class="flex flex-col">
          <p-floatlabel variant="on">
            <p-select
              formControlName="depositTypeId"
              [options]="depositTypeSelectOptions()"
              optionLabel="firstLabel"
              optionValue="id"
              optionDisabled="disabled"
              [filter]="true"
              [showClear]="false"
              styleClass="w-full"
              appendTo="body"
              (onChange)="onDepositTypeChange($event.value)"
            />
            <label> Deposit Type <span class="text-red-500">*</span> </label>
          </p-floatlabel>
        </div>
        <div class="flex flex-col">
          <p-floatlabel variant="on">
            <p-datepicker
              appendTo="body"
              formControlName="depositDueDate"
              [showIcon]="true"
              iconDisplay="input"
              dateFormat="mm/dd/yy"
              styleClass="w-full"
              inputId="on_label"
            />
            <label for="on_label"> Due Date <span class="text-red-500">*</span> </label>
          </p-floatlabel>
        </div>
      </div>
      @if (isSelectedDepositTypeOptions() && !addendumView()) {
        <div class="flex flex-col">
          <p-floatlabel variant="on">
            <p-select
              formControlName="addendumId"
              [options]="addendumChoices()"
              optionLabel="firstLabel"
              optionValue="id"
              placeholder=""
              [filter]="true"
              [showClear]="true"
              styleClass="w-full"
              appendTo="body"
            />
            <label class="text-body-sm-500 text-surface-700">
              Addendum
              @if (addendumRequiredValidators) {
                <span class="text-red-500">*</span>
              }
            </label>
          </p-floatlabel>
        </div>
      }
      <div class="flex flex-col">
        <p-floatlabel variant="on">
          <p-inputNumber
            formControlName="depositAmount"
            mode="currency"
            [currency]="currencyCode()"
            locale="en-CA"
            [minFractionDigits]="2"
            styleClass="w-full"
          />
          <label class="text-body-sm-500 text-surface-700"> Amount <span class="text-red-500">*</span> </label>
        </p-floatlabel>
        @if (depositAmountBelowPaid()) {
          <small class="text-body-xs text-amber-700">
            Payments already recorded ({{ activePaymentDeposit()!.received | currencyFormat }}) are more than this
            amount.
          </small>
        }
      </div>
    </form>
    <ng-template #footer>
      <div class="flex justify-end gap-2 pt-1">
        <p-button label="Cancel" severity="secondary" (onClick)="resetForm()" />
        <p-button
          [label]="depositService.depositId ? 'Update Deposit' : 'Add Deposit'"
          [disabled]="form.invalid"
          (onClick)="depositsSaved.emit()"
        />
      </div>
    </ng-template>
  </p-dialog>

  <div class="flex-1 min-h-0 overflow-auto mt-4">
    <!-- Tablet / desktop: two-column deposit | payment grid -->
    <div class="hidden md:flex md:flex-col min-w-[640px] rounded-none">
      <div class="flex sticky top-0 z-20 rounded-none shadow-divider-b">
        <div class="flex-1 bg-surface-100 px-4 py-2 rounded-none">
          <span class="text-body-xs-600 text-surface-500 uppercase tracking-wide">Deposit</span>
        </div>
        <div class="flex-1 bg-surface-100 px-4 py-2 rounded-none shadow-divider-r">
          <span class="text-body-xs-600 text-surface-500 uppercase tracking-wide">Payment</span>
        </div>
      </div>

      @for (row of depositRows(); track row.deposit.id) {
        <div class="flex rounded-none shadow-divider-b">
          <div
            class="flex flex-1 items-start justify-between gap-2 px-4 py-3 rounded-none"
            [ngClass]="{ 'bg-primary-50': isDepositSelected(row.deposit) }"
          >
            <ng-container *ngTemplateOutlet="depositInfo; context: { $implicit: row }" />
          </div>
          <div
            class="flex flex-1 min-h-[86px] flex-col px-4 py-3 rounded-none shadow-divider-r"
            [ngClass]="{
              'bg-primary-50': isDepositSelected(row.deposit),
              'justify-center': !row.payments.length
            }"
          >
            <ng-container *ngTemplateOutlet="paymentsColumn; context: { $implicit: row }" />
          </div>
        </div>
      }
    </div>

    <!-- Mobile: stacked deposit + payment cards -->
    <div class="flex md:hidden flex-col gap-3 px-2">
      <div class="sticky top-0 z-10 rounded-md bg-surface-100 px-4 py-2">
        <span class="text-body-xs-600 text-surface-500 uppercase tracking-wide">Deposit/Payment</span>
      </div>

      @for (row of depositRows(); track row.deposit.id) {
        <div
          class="flex flex-col overflow-hidden rounded-2xl border border-surface-200"
          [ngClass]="{ 'bg-primary-50': isDepositSelected(row.deposit) }"
        >
          <div class="flex items-start justify-between gap-2 px-4 py-3">
            <ng-container *ngTemplateOutlet="depositInfo; context: { $implicit: row }" />
          </div>
          <div class="flex flex-col rounded-none px-4 py-3 shadow-divider-t">
            <ng-container *ngTemplateOutlet="paymentsColumn; context: { $implicit: row }" />
          </div>
        </div>
      }
    </div>
  </div>
</div>

<ng-template #paymentsColumn let-row>
  @if (!row.payments.length) {
    <ng-container *ngTemplateOutlet="noPaymentInfo; context: { $implicit: row.deposit }" />
  } @else {
    @let expanded = expandedDepositIds().has(row.deposit.id);
    @let visiblePayments = expanded ? row.payments : row.payments.slice(0, 1);
    @let earlierCount = row.payments.length - 1;
    @for (payment of visiblePayments; track payment.id; let last = $last) {
      <div
        class="flex items-start justify-between gap-2 py-2"
        [ngClass]="{ 'border-b border-dashed border-surface-200': !last }"
      >
        <ng-container *ngTemplateOutlet="paymentInfo; context: { $implicit: payment, deposit: row.deposit }" />
      </div>
    }
    <div class="flex items-center justify-between gap-2 pt-1">
      @if (earlierCount > 0) {
        <button
          type="button"
          class="flex cursor-pointer items-center gap-1 border-0 bg-transparent p-0 text-body-xs text-surface-500 hover:bg-transparent hover:text-surface-700 hover:underline"
          (click)="toggleExpanded(row.deposit.id)"
        >
          @if (expanded) {
            Show fewer <i class="pi pi-chevron-up text-[10px]"></i>
          } @else {
            Show {{ earlierCount }} earlier {{ earlierCount === 1 ? 'payment' : 'payments' }}
            <i class="pi pi-chevron-down text-[10px]"></i>
          }
        </button>
      } @else {
        <span></span>
      }
      @if (canRecordPayment(row.deposit)) {
        <p-button
          label="Record Payment"
          icon="pi pi-plus"
          [outlined]="true"
          [rounded]="true"
          size="small"
          (onClick)="onAddPayment(row.deposit)"
        />
      }
    </div>
  }
</ng-template>

<ng-template #noPaymentInfo let-deposit>
  <div
    class="flex flex-1 items-center justify-between gap-2 rounded-xl border border-dashed border-surface-200 py-2 pl-4 pr-2"
  >
    <span class="text-body-xs text-surface-400">No payment yet</span>
    @if (canRecordPayment(deposit)) {
      <p-button
        label="Record Payment"
        icon="pi pi-plus"
        [outlined]="true"
        size="small"
        (onClick)="onAddPayment(deposit)"
      />
    }
  </div>
</ng-template>

<ng-template #paymentInfo let-payment let-deposit="deposit">
  <div class="flex items-start gap-2">
    <div
      class="flex size-12 shrink-0 items-center justify-center rounded-2xl overflow-hidden border"
      [ngClass]="{
        'cursor-pointer bg-primary-500/10 border-primary-500/30': payment.paymentImages?.length,
        'bg-surface-100 border-surface-200': !payment.paymentImages?.length
      }"
      (click)="payment.paymentImages?.length && openPaymentImagesDialog(payment.paymentImages)"
      [pTooltip]="payment.paymentImages?.length ? 'View' : ''"
      tooltipPosition="top"
    >
      @if (payment.paymentImages?.length) {
        <i class="pi pi-images text-primary-500 text-xl"></i>
      } @else {
        <span class="text-[8px] font-semibold uppercase leading-[1.1] text-surface-400 text-center">
          No<br />Image
        </span>
      }
    </div>
    <div class="flex flex-col gap-0.5">
      <span class="text-body-600 text-emerald-700" [ngClass]="{ 'text-surface-400 line-through': payment.returned }">
        {{ payment.paymentAmount | currencyFormat }}
      </span>
      <div class="flex xl:flex-row flex-col items-start xl:items-center gap-x-4 gap-y-0.5">
        <span class="flex flex-col lg:flex-row lg:items-center items-start gap-1 text-body-xs">
          <span class="text-surface-500">Ref:</span>
          <span class="text-surface-700 font-medium">{{ payment.referenceNo || '-' }}</span>
        </span>
        <span class="flex items-center gap-1 text-body-xs">
          <span class="text-surface-500">Date:</span>
          <span class="text-surface-700 font-medium">{{ payment.paymentDate | date: 'MM/dd/yyyy' }}</span>
        </span>
      </div>
      <span class="flex items-start xl:items-center flex-col xl:flex-row gap-1 text-body-xs">
        <span class="text-surface-500">Created By:</span>
        <span class="text-surface-700 font-medium"
          >{{ payment.createdByUserName || '-' }} on {{ payment.createdAt | date: 'MM/dd/yyyy' }}</span
        >
      </span>
    </div>
  </div>
  <div class="flex shrink-0 items-center gap-2">
    <span class="text-body-xs-600" [ngClass]="payment.returned ? 'text-red-500' : 'text-emerald-700'">
      {{ payment.returned ? 'Returned' : 'Paid' }}
    </span>
    @if (deposit.depositType.name === 'Options') {
      <p-button
        icon="pi pi-ellipsis-v"
        [text]="true"
        [rounded]="true"
        severity="secondary"
        size="small"
        (onClick)="openPaymentMenu($event, payment)"
      />
    }
  </div>
</ng-template>

<ng-template #depositInfo let-row>
  @let deposit = row.deposit;
  <div class="flex items-start gap-2">
    <!-- @if (canBulkDelete() && !addendumView()) {
      <div class="flex items-center pt-0.5">
        <p-checkbox
          [binary]="true"
          [ngModel]="isDepositSelected(deposit)"
          [disabled]="deposit.payments.length > 0 || !isOptionsDeposit(deposit)"
          (onChange)="toggleDepositSelection(deposit, $event.checked)"
        />
      </div>
    } -->
    <div class="flex flex-col gap-0.5">
      <span class="text-body-600 text-surface-700">{{ deposit.depositType.name }}</span>
      <div class="flex flex-col gap-1">
        @if (!addendumView()) {
          <span class="flex items-start xl:items-center flex-col xl:flex-row gap-1 text-body-xs">
            <span class="text-surface-500">Addendum:</span>
            <span class="text-surface-700 font-medium">{{ getAddendumLabel(deposit?.addendumId) || '-' }}</span>
          </span>
        }
        <span class="flex items-start xl:items-center flex-col xl:flex-row gap-1 text-body-xs">
          <span class="text-surface-500">Created By:</span>
          <span class="text-surface-700 font-medium"
            >{{ deposit.createdByUserName || '-' }} on {{ deposit.createdAt | date: 'MM/dd/yyyy' }}</span
          >
        </span>
      </div>
    </div>
  </div>
  <div class="flex shrink-0 items-start gap-2">
    <div class="flex flex-col items-end gap-0.5 text-right">
      <span class="text-body-600 text-emerald-700">{{ deposit.depositAmount | currencyFormat }}</span>
      <span
        class="flex items-center gap-1 text-body-xs"
        [ngClass]="row.isOverdue ? 'text-red-500' : 'text-surface-700'"
      >
        <span [ngClass]="{ 'text-surface-500': !row.isOverdue }">{{ row.isOverdue ? 'Overdue:' : 'Due:' }}</span>
        <span [ngClass]="{ 'font-medium': !row.isOverdue }">{{ deposit.depositDueDate | date: 'MM/dd/yyyy' }}</span>
      </span>
      @if (row.isFullyPaid) {
        @if (row.instalmentCount > 1) {
          <span class="rounded-full bg-emerald-100 px-2 py-0.5 text-[10px] font-semibold uppercase text-emerald-700">
            Paid · {{ row.instalmentCount }} instalments
          </span>
        } @else {
          <span class="flex items-center gap-1 text-body-xs-600 text-emerald-700">
            <i class="pi pi-check-circle text-body-xs"></i>Paid in full
          </span>
        }
      } @else if (row.instalmentCount > 0) {
        <span class="flex items-center gap-1 text-body-xs">
          <span class="text-surface-500">
            {{ row.instalmentCount }} {{ row.instalmentCount === 1 ? 'payment' : 'payments' }} ·
          </span>
          <span class="text-primary-500">Balance:</span>
          <span class="font-semibold text-sky-700">{{ deposit.due | currencyFormat }}</span>
        </span>
      }
    </div>
    @if (canManageDeposit(deposit)) {
      <p-button
        icon="pi pi-ellipsis-v"
        [text]="true"
        [rounded]="true"
        severity="secondary"
        size="small"
        (onClick)="openDepositMenu($event, deposit)"
      />
    }
  </div>
</ng-template>

<p-menu #depositMenu [model]="activeDepositMenuItems" [popup]="true" appendTo="body" />
<p-menu #paymentMenu [model]="activePaymentMenuItems" [popup]="true" appendTo="body" />

<p-dialog
  header="Record Payment"
  [visible]="depositService.addPayment"
  (visibleChange)="!$event && onCancelPayment()"
  [modal]="true"
  [closable]="true"
  appendTo="body"
  [style]="{ width: '32rem', maxWidth: '95vw' }"
  [pt]="{
    root: {
      class: '!rounded-[20px] !border !border-solid !border-surface-200 !bg-white !shadow-xl'
    }
  }"
>
  @if (activePaymentDeposit(); as activeDeposit) {
    <form [formGroup]="depositPaymentForm" class="flex flex-col gap-5">
      <div class="flex flex-col gap-2">
        <div
          class="flex flex-wrap items-center justify-between gap-2 rounded-2xl border border-solid border-amber-200 bg-amber-50 px-4 py-3"
        >
          <span class="text-body-sm-600 text-surface-700">{{ activeDeposit.depositType.name }} Deposit</span>
          <span class="text-body-600 text-emerald-700">{{ activeDeposit.depositAmount | currencyFormat }}</span>
        </div>
        @if (activePaymentRow(); as row) {
          @if (row.instalmentCount > 0) {
            <div class="flex flex-wrap items-center justify-between gap-2 px-1 text-body-xs">
              <span class="text-surface-500">
                {{ activeDeposit.received | currencyFormat }} collected · {{ row.instalmentCount }}
                {{ row.instalmentCount === 1 ? 'payment' : 'payments' }}
              </span>
              <span class="font-semibold text-orange-700">
                {{ row.isFullyPaid ? 'Fully paid' : (activeDeposit.due | currencyFormat) + ' remaining' }}
              </span>
            </div>
          }
        }
      </div>

      <div class="flex flex-col gap-1.5">
        <p-floatlabel variant="on">
          <p-inputNumber
            formControlName="paymentAmount"
            mode="currency"
            [currency]="currencyCode()"
            locale="en-CA"
            [minFractionDigits]="2"
            styleClass="w-full"
          />
          <label class="text-body-500 text-surface-700">Amount <span class="text-red-500">*</span></label>
        </p-floatlabel>
        @if (paymentExceedsOwed(activeDeposit)) {
          <small class="text-body-xs text-amber-700">
            This is more than the {{ owedBeforeThisPayment(activeDeposit) | currencyFormat }} still owed on this
            deposit.
          </small>
        }
      </div>

      <div class="grid grid-cols-2 gap-5">
        <div class="flex flex-col gap-1.5">
          <p-floatlabel variant="on">
            <p-datepicker
              appendTo="body"
              [showIcon]="true"
              iconDisplay="input"
              dateFormat="mm/dd/yy"
              formControlName="paymentDate"
              styleClass="w-full"
            />
            <label class="text-body-500 text-surface-700">Date <span class="text-red-500">*</span></label>
          </p-floatlabel>
        </div>
        <div class="flex flex-col gap-1.5">
          <p-floatlabel variant="on">
            <input pInputText formControlName="referenceNo" class="w-full" />
            <label class="text-body-sm-500 text-surface-700">Reference No.</label>
          </p-floatlabel>
        </div>
      </div>

      <div class="flex flex-col gap-2">
        <label class="text-body-sm-500 text-surface-700">Cheque Image</label>
        <div
          class="flex flex-col items-center gap-4 rounded-2xl border border-dashed border-surface-300 bg-white/60 px-[18px] py-[18px]"
        >
          <p-fileUpload
            mode="basic"
            chooseLabel="Upload"
            chooseIcon="pi pi-upload"
            accept="image/*"
            [multiple]="true"
            [auto]="true"
            [customUpload]="true"
            (uploadHandler)="onFilesSelected($event)"
          />
          <span class="text-body-sm text-surface-700">Drag and drop image here to upload.</span>
        </div>

        @if (attachments().length > 0) {
          <span class="text-body-xs-600 uppercase tracking-wide text-surface-500 pt-1">
            Attached ({{ attachments().length }})
          </span>

          <div class="flex flex-col gap-2 max-h-60 overflow-y-auto">
            @for (attachment of attachments(); track $index) {
              <div
                class="flex items-center justify-between gap-2 rounded-2xl border border-solid px-3 py-2 transition-colors"
                [ngClass]="
                  attachment.progress !== null
                    ? 'border-surface-200 bg-white/60'
                    : 'border-emerald-200 bg-emerald-50/60'
                "
              >
                @if (attachment.file && attachment.progress !== null) {
                  <span class="flex items-center gap-2 text-body-sm-500 text-surface-500">
                    <i class="pi pi-spin pi-spinner"></i>
                    Image {{ $index + 1 }} — {{ attachment.progress }}%
                  </span>
                } @else {
                  <span class="flex items-center gap-2 text-body-sm-500 text-surface-700">
                    <i class="pi pi-check-circle text-emerald-600"></i>
                    Image {{ $index + 1 }}
                  </span>
                }
                <p-button
                  icon="pi pi-times"
                  [text]="true"
                  [rounded]="true"
                  severity="danger"
                  size="small"
                  pTooltip="Remove"
                  tooltipPosition="top"
                  (onClick)="removeAttachment(attachment)"
                />
              </div>
            }
          </div>
        }
      </div>
    </form>
  }
  <ng-template #footer>
    <div class="flex justify-end gap-2 pt-1">
      <p-button label="Cancel" severity="secondary" (onClick)="onCancelPayment()" />
      <p-button
        label="Record Payment"
        [disabled]="depositPaymentForm.invalid"
        (onClick)="onDepositPaymentFormSubmitted(activePaymentDeposit()!)"
      />
    </div>
  </ng-template>
</p-dialog>

<p-confirmdialog appendTo="body" />

<lib-link-list-dialog
  header="Cheque Images"
  [(visible)]="viewImagesDialogVisible"
  [items]="selectedPaymentImageLinks()"
  emptyMessage="No images available"
/>
